module.exports = "// Move jQuery to a different namespace to avoid conflicts with other extensions\n\nvar solide = jQuery.noConflict();"